import React from 'react';

import { styled } from '@mui/material/styles';
import { TextField } from 'react-admin';

const StyledTextField = styled(TextField)({
    textTransform: 'capitalize',
});

const CapitalizedTextField = (props) => {
    return (
        <StyledTextField
            {...props}
        />
    );
};

export default CapitalizedTextField;
